import flatMap from 'lodash/flatMap';
import find from 'lodash/find';
import some from 'lodash/some';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';

import * as types from '../actions/actionTypes';
//import instList from '../bvcomponents/installation/instHardCode';

const initialState = {
  instOpened: false,
  instList: [],
  defaultInstallations: [],
};

let __installations = [];

export default function (state = initialState, action) {

  switch (action.type) {
    case types.ADD_TO_CART:
      return __tryAddToInstallation(state, action.payload.cartItems);
    case types.REMOVE_FROM_CART:
      return __tryRemoveFromInstallations(state, action.payload.cartItem);
    case types.TOGGLE_INST_OPENED:
    case types.SET_INST_LIST:
    case types.SET_DEFAULT_INST_LIST:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.REMOVE_INSTALLATION_SERVICE_FROM_CART:
      return __toggleInstallationServiceUsage(state, action.payload);
  }

  return state;

}

export function getInstallationsTotalCost(instList) {
  let cost = 0;
  flatMap(instList, group => group.services)
    .forEach(s => {
      if (s.selected) {
        cost += getInstallationCost(s);
      }
    });

  return cost;
}

export function getInstallationCost(installationService) {
  return installationService.hourly * installationService.price;
}

function __toggleInstallationServiceUsage(state, {installationService}) {
  const {instList} = state;
  for (let i = 0; i < instList.length; i++){
    for (let j = 0; j < instList[i].services.length; j++) {
      const service = instList[i].services[j];
      if ((service.fabricatorFeature_id === installationService.fabricatorFeature_id)
        && (service.fabricatorInstallation_id === installationService.fabricatorInstallation_id)){
        service.selected = !service.selected;
        return {...state, instList: cloneDeep(instList)};
      }
    }
  }

  return state;
}

function __tryAddToInstallation(state, cartItems) {
  let hasChanges = false;
  const {instList} = state;

  cartItems.filter(cartItem => cartItem.quantity).forEach(cartItem => {
    const ID = cartItem.cartFeature.dbFeature.id;
    const allInstallations = __getInstallations(state.defaultInstallations);
    const installations = allInstallations.filter(inst => {
      return inst && (inst.fabricatorFeature_id === ID)
    });

    if (installations.length) {
      let instGroup = find(instList, {title: cartItem.selectionGroup});
      if (!instGroup) {
        instGroup = {
          title: cartItem.selectionGroup,
          services: [],
          description: 'Do you wand to add installation for ' + cartItem.selectionGroup,
          enabled: false
        };
        instList.push(instGroup);
      }

      installations.forEach(installation => {
        const service = some(instGroup.services, {
          // fabricatorFeature_id: id, // removed this check cause they are different, but we need to remove duplicates
          fabricatorInstallation_id: installation.fabricatorInstallation_id
        });
        if (!service) {
          const selected = installation.autoAddWithProduct;
          instGroup.services.push({
            fabricatorFeature_id: cartItem.cartFeature.dbFeature.id,
            title: installation.installationName,
            hourly: installation.defaultQuantity || 1,
            price: installation.price,
            description: installation.description,
            fabricatorInstallation_id: installation.fabricatorInstallation_id,
            selected,
            autoAddWithProduct: installation.autoAddWithProduct,
            defaultQuantity: installation.defaultQuantity,
            hideQuantity: installation.hideQuantity,
            unit: installation.unit
          });
          if (selected) {
            instGroup.enabled = true;
          }
          hasChanges = true;
        }
      });
    }
  });

  return hasChanges ? {...state, instList: cloneDeep(instList)} : state;
}

function __tryRemoveFromInstallations(state, cartItem) {
  const {instList} = state;
  const ID = cartItem.cartFeature.dbFeature.id;
  const allInstallations = __getInstallations(state.defaultInstallations);
  const installations = allInstallations.filter(inst => {
    return inst.fabricatorFeature_id === ID
  });
  if (installations.length) {
    installations.forEach(installation => {
      let instGroupIdx = findIndex(instList, {title: cartItem.selectionGroup});
      if (instGroupIdx !== -1) {
        const serviceIdx = findIndex(instList[instGroupIdx].services, {
          fabricatorFeature_id: cartItem.cartFeature.dbFeature.id,
          fabricatorInstallation_id: installation.fabricatorInstallation_id
        });
        if (serviceIdx !== -1) {
          instList[instGroupIdx].services.splice(serviceIdx, 1);
          if (!instList[instGroupIdx].services.length) {
            // remove group as well
            instList.splice(instGroupIdx, 1);
            return {...state, instList: cloneDeep(instList)};
          }
        }
      }
    });
  }

  return {...state, instList: cloneDeep(instList)};
}

function __getInstallations(defaultInstallations) {
  if (defaultInstallations && defaultInstallations.length && __installations && !__installations.length) {
    __installations = flatMap(defaultInstallations, i => i.installations);
    __installations = __installations.filter(i => {
      return i && (i.autoAddWithProduct || i.customerAdd || (i.employeesOnly && document.kvConfig.isBackend));
    })
  }

  return __installations;
}

